import { useEffect, useState } from "react";

import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import { useGetGiftPointRatio } from "../../hooks/ShopCart/cart.hooks";
import GiftPoint from "./components/GiftPoint";
import OrderInquiry from "./components/OrderInquiry";
import SiderMenu from "./components/SiderMenu";
import UserInfo from "./components/UserInfo";
import styles from "./style.module.scss";
const UserCenter = () => {
  const { t } = useTranslation();
  const [nowTab, setNowTab] = useState("");
  const [searchParams] = useSearchParams();
  const { data: giftPointStatus } = useGetGiftPointRatio({});

  const tabs = [
    {
      label: t("normal.userinfo"),
      key: "userinfo",
      hide: false,
    },
    {
      label: t("normal.orderinquiry"),
      key: "orderinquiry",
      hide: false,
    },
    {
      label: t("orderIquiry.giftpoint.record"),
      key: "giftpoint",
      hide:
        giftPointStatus?.status === "0" ||
        process.env.REACT_APP_PROD_NAME_DEV === "2esim",
    },
  ];
  const componentRender: any = {
    userinfo: () => <UserInfo />,
    orderinquiry: () => <OrderInquiry nowTab={nowTab} />,
    giftpoint: () => <GiftPoint nowTab={nowTab} />,
  };

  useEffect(() => {
    const queryTab = searchParams.get("tab");
    if (queryTab) {
      const found = tabs.find((tab) => tab.key === queryTab);
      if (found) {
        setNowTab(queryTab);
        return;
      }
      setNowTab("userinfo");
    } else {
      setNowTab("userinfo");
    }
  }, []);

  return (
    <div className={styles.userCenter}>
      <div className={styles.sider}>
        <SiderMenu tabs={tabs} nowTab={nowTab} setNowTab={setNowTab} />
      </div>
      <div className={styles.content}>
        {componentRender[nowTab] && componentRender[nowTab]()}
      </div>
      {/* <Tabs
        tabPosition={"left"}
        destroyInactiveTabPane={true}
        items={[
          {
            label: t("normal.userinfo"),
            key: "userinfo",
            children: <UserInfo />,
          },
          {
            label: t("normal.orderinquiry"),
            key: "orderinquiry",
            children: <OrderInquiry />,
          },
        ]}
      /> */}
    </div>
  );
};

export default UserCenter;
